import type { MedicalTestParameterFaqTranslation } from "@cabocheck/shared";
import { useTranslation } from "react-i18next";
import { FaqItem } from "~/features/faq/faq_item";

type ParameterFaqItem = MedicalTestParameterFaqTranslation | { question?: string | null; response?: string | null };

export function ParameterFaqs({ parameter }: { parameter: { name: string; faqs: ParameterFaqItem[] } }) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <h2>{t("Fragen und Antworten zu {{name}}", { name: parameter.name })}</h2>
      <div className="grid gap-3">
        {parameter.faqs.map((item: any) => (
          <FaqItem key={item.question} title={item.question} answer={item.response} />
        ))}
      </div>
    </div>
  );
}
